import React from "react";
import {
    Row,
    Col,
    Input,
    Tag,
    Avatar,
    Button,
    Space,
    Dropdown,
    Popconfirm,
    message,
    Tooltip,
    Modal,
    Image,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext, StoreProvider } from "../store/RootStore";
import { Link } from "react-router-dom";
import ShareModalWindow from "./ShareModalWindow";
import dayjs from "dayjs";
import {
    DeleteFilled,
    PlusOutlined
} from "@ant-design/icons";

import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import AddButton from "./AddButton";
import DeleteConfirm from "./DeleteConfirm";
import config from "../config";
import withRouter from "../withRouter";
import AssignJobOrderStore from "../store/AssignJobOrderStore";
import CompanyStore from "../store/CompanyStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";

class AssignJobOrderList extends React.Component {
    constructor(props) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.companyStore = new CompanyStore(this);
        this.onDelete = this.onDelete.bind(this);

        this.assignJobOrderStore = new AssignJobOrderStore();
        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            openConfirm: false,
            confirmLoading: false,
            companyId: "",
            loadList: 0,
            company_value_label: "",
        };

    }
    async componentDidMount() {
        // this.setState({ pageSize: 50, companyId: this.props.getUserData().userCompanyId ? this.props.getUserData().userCompanyId : "" });
        this.setState({ pageSize: 50, companyId: this.context.viewStateStore.assignJobOrderObject.companyId ? this.context.viewStateStore.assignJobOrderObject.companyId : this.props.getUserData().userCompanyId });

        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {

            this.setState(
                { companyId: this.props.getUserData().userCompanyId },
                () => this.handleSearch()  // RUN AFTER STATE UPDATED
            );
        }


        const singleData = await this.companyStore.getCompanyDataById(
            this.context.viewStateStore.assignJobOrderObject.companyId
        );
        await this.setState({ loadList: 1, company_value_label: singleData }); //need to reload data
        if (this.context.viewStateStore.assignJobOrderObject.companyId) {
            await this.handleSearch()
        }
        await this.setState({ loadList: 1 }); //need to reload data
        await this.setState({ company_value_label: singleData });

        this.columns = [
            {
                title: this.context.translate("_JOB_ORDER_ID_"),
                // width: 150,
                dataIndex: "stId",
                key: "stId",
                render: (val, record) => {
                    if (record.isNew == 1) {
                        // Editable job order → show Link
                        return (
                            <Link
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.onEdit(record);
                                }}
                            >
                                {val}
                            </Link>
                        );
                    }

                    return <span>{val}</span>;
                },
                // fixed: "left",
            },
            {
                title: this.context.translate("_CREATED_ON_"),
                // width: 150,
                dataIndex: "createDate",
                key: "createDate",
            },
            {
                // title: "Zone Details",
                title: this.context.translate("_JOB_ORDER_START_DATE_"),
                // width: 150,
                dataIndex: "routestartDate",
                key: "routestartDate",
                render: (_, record) => {
                    return record.routestartDate
                        ? dayjs(record.routestartDate, "YYYY-MM-DD HH:mm:ss").format(
                            "DD-MM-YYYY hh:mm A"
                        )
                        : "";
                }
            },
            {
                title: this.context.translate("_JOB_ORDER_END_DATE_"),
                // width: 150,
                dataIndex: "routestopDate",
                key: "routestopDate",
                render: (_, record) => {
                    return record.routestopDate
                        ? dayjs(record.routestopDate, "YYYY-MM-DD HH:mm:ss").format(
                            "DD-MM-YYYY hh:mm A"
                        )
                        : "";
                }
            },
            {
                title: this.context.translate("_UNIT_"),
                // width: 150,
                dataIndex: "vehicleNo",
                key: "vehicleNo",
                render: (_, record) => {
                    if (record.vehicleNo && record.operationalCardNo) {
                        return `${record.vehicleNo} / ${record.operationalCardNo}`;
                    }
                    return record.vehicleNo;
                }
            },
            {
                title: this.context.translate("_DRIVERS_"),
                // width: 150,
                dataIndex: "driverName",
                key: "driverName",
            },

            {
                title: this.context.translate("_ACTION_"),
                dataIndex: "Action",
                fixed: "right",
                render: (_, record) => {
                    let tripPoints = record.RoutePoints;
                    let data = [];
                    tripPoints.forEach((val) =>
                        data.push(`${val.latitude},${val.longitude}`)
                    );
                    return (
                        <>
                            <Space>
                                <DeleteConfirm
                                    onConfirm={(e) => {
                                        e.preventDefault();
                                        this.onDelete(record);
                                    }}
                                >
                                    <Link>
                                        <Tooltip
                                            title={this.context.translate("_DELETE_TRIP_DETAILS_")}
                                            color={config.tooltipColorDelete}
                                            placement="bottom"
                                        >
                                            <DeleteFilled style={{ color: config.deleteColor }} />
                                        </Tooltip>
                                    </Link>
                                </DeleteConfirm>
                            </Space>
                        </>
                    );
                }
            }
        ];
    }
    onEdit = async (record) => {
        console.log(record);
        const stId = record.stId;
        await this.context.viewStateStore.setAssignJobOrderStates({
            companyId: record.companyId,
        });
        if (stId) {
            this.props.navigate("/assignjoborderaddnew/" + stId);
        }
    };
    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        await this.handleSearch();
    }

    async handleChange(comp) {
        await this.setState({ companyId: comp.value });
        console.log(comp);
        // await this.assignJobOrderStore.loadData(comp.value)
        const singleData = await this.companyStore.getCompanyDataById(comp.value);
        console.log(singleData);
        await this.setState({ company_value_label: singleData });

        await this.setState({ loadList: 1 });
        await this.handleSearch();
    }

    async handleSearch() {
        this.setState({ loading: true });
        await this.assignJobOrderStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            searchField: this.state.searchField,
            companyId: this.state.companyId,
        });
        await this.setState({ loadList: 1 });
    }
    async onDelete(record) {
        console.log(record);
        const response = await this.assignJobOrderStore.deleteJobOrder({
            stId: record.stId,
        });
        if (response?.data?.success === "S") {
            message.success(response.data.message);
            this.handleSearch();
        } else {
            message.error(response.data.message);
        }
    }
    refreshList = () => {
        this.setState({ loadList: 0 });
        this.handleSearch();
    };
    handleClear = async () => {
        await this.setState({
            company_value_label: null,
            companyId: "",
        });
    };
    render() {
        console.log("in render");
        return (
            <><div className="listHeader">
                <Row className="listInputRow">
                    <Col span={16}>
                        <Space>
                            <CompanyAutocomplete
                                className="searchInput"
                                onChange={this.handleChange}
                                value={
                                    this.state.company_value_label
                                        ? this.state.company_value_label
                                        : null
                                }
                                // allowClear={true}
                                style={{ width: 200 }}
                                allowClear={true}
                                onClear={this.handleClear}
                            />
                        </Space>
                    </Col>

                    <Col span={6}>
                        <Space
                            style={{
                                float:
                                    this.context.locale.direction === "ltr" ? "right" : "left",
                            }}
                        >
                            <Tooltip
                                title={this.context.translate("_REFRESH_")}
                                placement="bottom"
                            >
                                <Image
                                    style={{
                                        height: 18,
                                        // marginInlineEnd: "40px",
                                        alignItems: "center",
                                        cursor: "pointer",
                                    }}
                                    src={refreshIcon}
                                    onClick={() => this.refreshList()}
                                ></Image>
                            </Tooltip>

                            {/* {this.props.canCreate("assignRoutelist") && ( */}
                            <Button
                                className="addButtonClass"
                                onClick={() => this.props.navigate("/assignjoborderaddnew")}
                            >
                                <Image
                                    style={{ marginInlineEnd: "5px", width: 13 }}
                                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                                ></Image>
                                {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                            </Button>
                            {/* )} */}
                        </Space>
                    </Col>
                </Row>


                <ListTable
                    current={this.state.currentPage}
                    total={this.assignJobOrderStore?.total}
                    columns={this.columns}
                    dataSource={this.assignJobOrderStore?.jobDataArray}
                    loading={this.assignJobOrderStore?.loading}
                    onChange={this.handleTableChange}
                />
            </div>




            </>
        );
    }
}
AssignJobOrderList.contextType = StoreContext;
export default observer(withRouter(AssignJobOrderList));

//
